import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

interface ProtectedRouteProps {
  allowedRoles: ('professional' | 'assistant' | 'patient')[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles }) => {
  // 1. Leer usuario del almacenamiento
  const userStr = localStorage.getItem('user');
  const isLoggedIn = localStorage.getItem('isLoggedIn') === 'true';

  if (!userStr || !isLoggedIn) {
    return <Navigate to="/login" replace />;
  }

  const user = JSON.parse(userStr);

  // 2. Determinar el rol REAL del usuario
  let currentRole = 'patient'; // Por defecto es paciente
  
  if (user.es_profesional) {
    currentRole = 'professional';
  } else if (user.isAssistant || user.is_assistant) {
    currentRole = 'assistant';
  }

  // 3. Verificar si el rol tiene permiso para entrar
  // "any" se usa aquí para evitar conflictos de tipos estrictos si allowedRoles no coincide exacto
  if (!allowedRoles.includes(currentRole as any)) {
    console.warn(`⛔ Acceso denegado: Rol ${currentRole} intentó entrar a ruta protegida.`);
    
    // Redirigir al dashboard que LE CORRESPONDE
    if (currentRole === 'professional') return <Navigate to="/dashboard/profesional" replace />;
    if (currentRole === 'assistant') return <Navigate to="/assistant/dashboard" replace />;
    return <Navigate to="/dashboard/paciente" replace />;
  }

  // 4. Si pasó la prueba, mostrar la página
  return <Outlet />;
};

export default ProtectedRoute;